<ion-col>
	<div>{{ label }}</div>
</ion-col>
